<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header/>
    <Scroll/>
    <div class="mall_mypageWrap">
      <div class="mall_widthWrap">
        <h2 class="mall_pageTopTit">로그인</h2>
        <table class="mallMy_userInfoTable" cellpadding="0" cellspacing="0" summary="로그인">
          <caption>로그인</caption>
          <colgroup>
            <col width="20%">
            <col width="*">
          </colgroup>
          <tbody>
            <tr>
              <th>
                아이디
              </th>
              <td>
                <input
                  type = "text"
                  id = 'customer_login_ID'
                  v-model="formData.customerLoginID"
                  maxlength="15"
                  placeholder="아이디를 입력하세요"
                  @keydown.enter="check_form"
                >
                <p class="mallMy_userIT_subTxt">{{errorData.customerLoginIDError}}</p>
              </td>
            </tr>
            <tr>
              <th>
                비밀번호
              </th>
              <td>
                <input
                  type = "password"
                  id = 'customer_password'
                  v-model="formData.customerPassword"
                  maxlength="20"
                  placeholder="비밀번호를 입력하세요"
                  @keydown.enter="check_form"
                >
                <p class="mallMy_userIT_subTxt">{{errorData.customerPasswordError}}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="mallMy_uIT_btns">
          <button v-on:click="check_form">
            로그인
          </button>
        </div>
        <div class="mallMy_logoinBtnBox">
          <a href="/Join">회원가입</a>
          <a href="/SearchIdPassword?search_status=1">아이디찾기</a>
          <a href="/SearchIdPassword?search_status=2">비밀번호찾기</a>
        </div>
        <div class="mallMy_easyLogoinBtnBox">
          <a
              :href="kakaoLoginUrl"
            >
            <img src="../../../assets/images/icon/login_kakao.png" alt="카카오로그인">
            카카오 로그인
          </a>
          <a
              :href="naverLoginUrl"
            >
            <img src="../../../assets/images/icon/login_naver.png" alt="네이버로그인">
            네이버 로그인
          </a>
        </div>
        <div class="mallMy_nonLogoinBox">
          <p v-if="$route.query.buy_status === '1'">비회원님도 상품구매가 가능하나 다양한 회원혜택에서 제외됩니다.</p>
          <a v-if="$route.query.buy_status === '1'" href="/Order">비회원 구매</a>
          <a @click="toggleNonMemberOrderInput" >비회원 주문조회</a>
          <div v-if="showNonMemberOrderInput" class="mallMy_nonLogoinBox_form">
            <p class="mallMy_nonLogoinBox_tit">비회원 주문조회</p>
            <div class="mallMy_nonLogoinBox_box">
              <p class="mallMy_nonLogoinBox_subTit">주문자명</p>
              <input
                type="text"
                v-model="nonMemberOrderData.orderReceiveName"
                placeholder="받는 사람을 입력하세요"
              >
            </div>
            <div class="mallMy_nonLogoinBox_box">
              <p class="mallMy_nonLogoinBox_subTit">전화번호</p>
              <input
                type="text"
                v-model="nonMemberOrderData.orderPhoneNumber"
                placeholder="휴대전화를 입력하세요"
              >
            </div>
            <button @click="submitNonMemberOrder" class="mallMy_nonLogoinBox_btn">조회하기</button>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Spiner from '../Section/Spiner.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  removeWhitespace,
  validateEngNum,
  validatePassword
} from '../../ETC/Validation.vue'
import {
  check_login,
  get_order_non_member,
  base_homepage_url_export
} from '../../ETC/Axios.vue'

export default {
  name: 'Login',
  components: {
    Header: Header,
    Footer: Footer,
    Spiner: Spiner,
    Scroll
  },
  setup () {
    const today = new Date()
    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    const oneMonthAgo = new Date()
    oneMonthAgo.setMonth(today.getMonth() - 1)
    return {
      formData: ref({
        customerLoginID: '',
        customerPassword: ''
      }),
      errorData: ref({
        customerLoginIDError: '',
        customerPasswordError: ''
      }),
      statusData: ref({
        customerLoginStatus: false,
        customerPasswordStatus: false,
        spinnerStatus: false
      }),
      showNonMemberOrderInput: ref(false),
      nonMemberOrderData: ref({
        orderReceiveName: '',
        orderPhoneNumber: '',
        startDate: formatDate(oneMonthAgo),
        endDate: formatDate(today)
      })
    }
  },
  watch: {
    'formData.customerLoginID': function (value) {
      this.formData.customerLoginID = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerLoginIDError = '아이디는 필수 입력입니다.'
        this.statusData.customerLoginStatus = false
      } else if (removeWhitespace(value).length < 5) {
        this.errorData.customerLoginIDError = '아이디는 최소 6자이상 입력해야 합니다.'
        this.statusData.customerLoginStatus = false
      } else if (validateEngNum(removeWhitespace(value))) {
        this.errorData.customerLoginIDError = ''
        this.statusData.customerLoginStatus = true
      } else {
        this.errorData.customerLoginIDError = '한글 및 특수문자는 입력할 수 없습니다.'
        this.statusData.customerLoginStatus = false
      }
    },
    'formData.customerPassword': function (value) {
      this.formData.customerPassword = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerPasswordError = '비밀번호는 필수 입력입니다.'
        this.statusData.customerPasswordStatus = false
      } else if (validatePassword(removeWhitespace(value))) {
        this.errorData.customerPasswordError = ''
        this.statusData.customerPasswordStatus = true
      } else {
        this.errorData.customerPasswordError = '최소 8자리 / 숫자, 특수문자 각 1회 이상을 입력해야 합니다.'
        this.statusData.customerPasswordStatus = false
      }
    },
    'nonMemberOrderData.orderPhoneNumber': function (value) {
      const cleaned = value.replace(/\D/g, '') // 숫자만 남기기
      if (cleaned.length <= 3) {
        this.nonMemberOrderData.orderPhoneNumber = cleaned
      } else if (cleaned.length <= 7) {
        this.nonMemberOrderData.orderPhoneNumber = `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`
      } else {
        this.nonMemberOrderData.orderPhoneNumber = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`
      }
    }
  },
  computed: {
    naverLoginUrl () {
      return `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=eMwQ1Lt9KzkDD6ouf20D&state=STATE_STRING&redirect_uri=${base_homepage_url_export}NaverLogin`
    },
    kakaoLoginUrl () {
      return `https://kauth.kakao.com/oauth/authorize?client_id=fe341811021a94effc6d23e8efe40641&redirect_uri=${base_homepage_url_export}KaKaoLogin&response_type=code`
    }
  },
  methods: {
    toggleNonMemberOrderInput () {
      this.showNonMemberOrderInput = !this.showNonMemberOrderInput
    },
    submitNonMemberOrder () {
      const { orderReceiveName, orderPhoneNumber, startDate, endDate } = this.nonMemberOrderData
      if (!orderReceiveName || !orderPhoneNumber) {
        alert('주문자명과 전화번호를 모두 입력해주세요.')
        return
      }

      get_order_non_member(orderReceiveName, orderPhoneNumber, startDate, endDate, 'orders')
        .then(result => {
          if (result.length > 0) {
            alert('주문 내역이 조회되었습니다.')
            this.$router.push({
              path: '/My',
              query: {
                myID: 1,
                orderReceiveName,
                orderPhoneNumber
              }
            })
          } else {
            alert('조회된 주문 내역이 없습니다. 다시 확인해주세요.')
          }
        })
    },
    check_form: function () {
      if (
        this.statusData.customerLoginStatus &&
        this.statusData.customerPasswordStatus
      ) {
        this.statusData.spinnerStatus = true
        check_login(
          this.formData.customerLoginID,
          this.formData.customerPassword
        ).then(result => {
          if (result === 1) {
            window.location.href = '/'
          } else {
            this.statusData.spinnerStatus = false
            alert('아이디 또는 비밀번호를 확인해주세요.')
          }
        })
      } else {
        alert('ID 및 비밀번호를 확인해주세요.')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Login/Login.vue